import React, { useEffect, useState, useRef } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import { getStates } from "requests/region/index.tsx";
import { MSpinner } from "components/Shared";

const AppraiserInterview = () => {
  const [states, setStates] = useState();
  const [selectedStates, setSelectedStates] = useState([]);
  const mounted = useRef(true);

  useEffect(() => {
    getStates(setStates, mounted);

    // gotta include some google analytics per request. i feel so dirty :(
    let _gaq = _gaq || [];
    _gaq.push(["_setAccount", "UA-11782403-10"]);
    _gaq.push(["_trackPageview"]);
    (function() {
      let ga = document.createElement("script"); ga.type = "text/javascript"; ga.async = true;
      ga.src = ("https:" == document.location.protocol ? "https://ssl" : "http://www") + ".google-analytics.com/ga.js";
      let s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ga, s);
    })();
  }, []);

  const stateNameMap = {
    "Chris Olson": {
      states: ["NC", "FL", "PA", "NY", "IL", "TN", "NJ", "VA", "WV", "MA", "ME", "CT", "NH", "RI", "DE", "VT", "DC"],
      link: "https://outlook.office365.com/owa/calendar/ChrisOlson@muellerreports.com/bookings/",
    },
    "Jasmine Chang": {
      states: ["CA"],
      link: "https://outlook.office365.com/owa/calendar/JasmineChang1@muellerreports.com/bookings/",
    },
    "Rabeeha Tahir": {
      states: ["TX", "MI", "AZ", "CO", "MD", "ID", "MO", "NM", "KS", "UT", "SD", "MT", "NV", "WI", "NE", "HI", "AK", "IA", "ND", "WY"],
      link: "https://outlook.office365.com/owa/calendar/RabeehaTahir@muellerreports.com/bookings/",
    },
    "Shanna McCollum": {
      states: ["OH", "OR", "IN", "KY", "WA", "GA", "MS", "LA", "AR", "SC", "AL", "MN", "OK"],
      link: "https://outlook.office365.com/owa/calendar/ShannaMcCollum@muellerreports.com/bookings/",
    },
  };

  const isStateSelected = state => selectedStates.indexOf(state.abbreviation) > -1;

  const stateToggled = state => {
    let selStates;
    if (isStateSelected(state)) selStates = selectedStates.filter(s => s !== state.abbreviation);
    else selStates = [...selectedStates, state.abbreviation];

    setSelectedStates(selStates);
  };
  
  let link;

  if (selectedStates.length) {
    let keys = Object.keys(stateNameMap);
    let matches = keys.map(k => ({ name: k, count: 0 }));

    keys.forEach(k => {
      if (stateNameMap[k].states.some(x => selectedStates.some(s => x.indexOf(s) > -1))) matches.find(m => m.name === k).count ++;
    });

    // sort by highest count, or alphabetical next
    matches.sort((a, b) => {
      if (a.count === b.count) return a.name.localeCompare(b.name); //if the count is the same then sort alphabetically so we always make consistent picks
      else return b.count - a.count;
    });

    link = stateNameMap[matches[0].name].link;
  }

  return (
    <div className="appraiser-interview-bg">
      {/* need this div here so we can have a padded border on the page */}
      <div className="appraiser-interview">
        <div className="header">
            <a href="https://www2.muellerreports.com/"><img src="//www2.muellerreports.com/wp-content/uploads/2016/11/Mueller-logo-web.png" alt="Mueller. Superior reports. Exceptional people." /></a>
            Superior reports. Exceptional people.
        </div>
        <div className="content-scroll">
          <div className="subheader">
            <div className="valuation-services">
              <h1>Valuation Services</h1>
              <h2>Accurate and timely real estate valuations.</h2>
            </div>
            <div className="text">
              At Mueller, we believe that our relationships with our appraisers is paramount to delivering our clients with accurate, compliant, and consistent real estate appraisal and evaluation reports. As a leader in the appraisal modernization space, our focus is on the pivotal role that appraisers play in the future of valuation practice. Having been the first to pioneer a bifurcated appraisal workflow on forward origination loans, Mueller has positioned itself as a leading innovator. We leverage new technologies and processes that improve the experience for both our appraisers and our clients. We bring our own proprietary software, professional field staff, and a fully dedicated support coordinator together to help our appraisers complete efficient, accurate reports- all from their desk.
              <br />
              <br />
              Click <a href="https://www2.muellerreports.com/wp-content/uploads/2021/09/Mueller_HybridAppraisal_FAQs.pdf" target="_blank">here</a> for frequently asked questions on hybrid appraisals.
            </div>
          </div>

          <form>
            {(states ?
            <>
              <FormLabel component="legend">In what state(s) are you interested in working for Mueller?</FormLabel>
              <div className="state-list">
                {states.map(s => (
                  <FormControlLabel
                    key={s.name}
                    control={<Checkbox checked={isStateSelected(s)} onChange={() => stateToggled(s)} name={s.name} color="primary" />}
                    label={s.name}
                  />))}
              </div>
            </> : <MSpinner />)}
            <Button disabled={!link} onClick={() => window.location.href = link} size="large">Proceed To Booking</Button>
          </form>
        </div>
      </div>
    </div>);
};

export default AppraiserInterview;
